"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedElement = exports.EmbedPreview = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const react_embed_1 = tslib_1.__importDefault(require("react-embed"));
const Paper_1 = require("@jsonjoy.com/ui/lib/4-card/Paper");
const Placeholder_1 = require("@jsonjoy.com/ui/lib/3-list-item/Placeholder");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const slate_react_1 = require("slate-react");
const Favicon_1 = require("@jsonjoy.com/ui/lib/1-inline/Favicon");
const VoidSelectionOverlay_1 = require("./VoidSelectionOverlay");
const blockClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    pb: '18px',
    bxz: 'border-box',
});
const previewClass = (0, nano_theme_1.rule)({
    d: 'flex',
    fld: 'column',
    gap: '10px',
    us: 'none',
});
const getEmbedHost = (url) => {
    try {
        return new URL(url).hostname.replace(/^www\./, '');
    }
    catch {
        return 'external content';
    }
};
const EmbedFallback = ({ url }) => {
    const styles = (0, context_1.useStyles)();
    return (React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer", style: {
            display: 'flex',
            boxSizing: 'border-box',
            borderRadius: 8,
            margin: -16,
            padding: 16,
            border: '1px solid ' + styles.g(0.86),
            flexDirection: 'column',
            gap: '4px',
            textDecoration: 'none',
            color: styles.g(0.16),
            userSelect: 'none',
        } },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600 } },
            React.createElement(Favicon_1.Favicon, { url: url, size: 16 }),
            React.createElement("span", null, getEmbedHost(url))),
        React.createElement("div", { style: {
                fontSize: '13px',
                lineHeight: 1.45,
                color: styles.g(0.36),
                wordBreak: 'break-all',
            } }, url)));
};
const EmbedPreview = ({ url, caption, compact, selected, width = 720 }) => {
    const styles = (0, context_1.useStyles)();
    return (React.createElement("div", { className: previewClass },
        React.createElement(Paper_1.Paper, { noOutline: true, style: {
                margin: '4px 0',
                overflow: 'hidden',
                position: 'relative',
            } },
            React.createElement("div", { style: { padding: compact ? 12 : 16 } },
                React.createElement(react_embed_1.default, { url: url, width: width, isDark: !styles.light, fallback: React.createElement(Placeholder_1.Placeholder, null), renderVoid: () => React.createElement(EmbedFallback, { url: url }) })),
            React.createElement(VoidSelectionOverlay_1.VoidSelectionOverlay, { selected: !!selected })),
        !!caption && (React.createElement("div", { style: {
                textAlign: 'center',
                fontSize: '13px',
                lineHeight: 1.4,
                color: styles.g(0.42),
            } }, caption))));
};
exports.EmbedPreview = EmbedPreview;
const EmbedElement = ({ attributes, children, element }) => {
    const isSelected = (0, slate_react_1.useSelected)();
    const isFocused = (0, slate_react_1.useFocused)();
    const selected = isSelected && isFocused;
    return (React.createElement("div", { ...attributes, className: blockClass },
        React.createElement("div", { contentEditable: false },
            React.createElement(exports.EmbedPreview, { url: element.url, width: element.width ?? 720, caption: element.caption, selected: selected })),
        children));
};
exports.EmbedElement = EmbedElement;
